(
    function (skyward, $, undefined)
    {
        skyward.staarfieldoverride = skyward.staarfieldoverride || {};
        
        var init = function (selector)
        {
            "use strict";
            var pageCheck = $(selector).find("#7EF25DAF-6A67-481C-A68A-A900380F62FA");

            if (!pageCheck.length > 0)
            {
                return;
            }
            GetTrexStudentDetails();
            $(".NextPrevClick").click(function () { GetNextPrevTrexStudentDetails(); });
        };

        function GetTrexStudentDetails()
        {
            $(document).on("mousedown", ".templatedResult", function (event)
            {
                GoToDetails($(this).find("#StudentID").attr("value"));
            });
        }

        function GetNextPrevTrexStudentDetails()
        {
            GoToDetails($(event.currentTarget).data("studentid"));
        }

        function GoToDetails(id)
        {
            var postData = { "id": id };

            $.ajax(
            {
                url: skyward.global.virtualDir + "/StateReportingTX/TRExExport/GetDetailScreen/",
                type: "POST",
                data: postData,
                success: function (data) {
                    skyward.window.loadContent('full', 'StateReportingTX', 'TRExExport', 'Details', data.TRExStudentID);
                }
            });
        }
        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);